
export default {
  props: {
    block: {
      type: Object,
      required: true,
    },
    background: {
      type: String,
      default: ``,
    },
  },
  computed: {
    galleryType () {
      return this.block.gallery_type;
    },
    media () {
      if (this.galleryType === `video`) {
        return this.block.videos;
      }
      return this.block.images;
    },
    perPage () {
      return this.block.media_items_per_page;
    },
    openToModal () {
      return this.block.open_to_modal;
    },
    equalHeight () {
      return this.block.equal_height;
    },
    hasLink () {
      if (this.galleryType === `partner`) {
        return this.block.include_partner_link;
      }
      return false;
    },
    partnerCategories () {
      if (this.galleryType === `partner`) {
        return this.block.partner_categories;
      }
      return false;
    },
  },
};
